import {
  FrameworkListView,
  FrameworkNewView,
  FrameworkEditView,
  FrameworkShowView,
} from '@/views/authenticated/frameworks';

export default [
  {
    path: '/frameworks',
    name: 'app_framework_list',
    meta: { title: 'Frameworks' },
    component: FrameworkListView,
  },
  {
    path: '/frameworks/:framework',
    name: 'app_framework_show',
    meta: { title: 'Frameworks' },
    component: FrameworkShowView,
  },
  {
    path: '/frameworks/new',
    name: 'app_framework_new',
    meta: { title: 'Add a Framework' },
    component: FrameworkNewView,
  },
  {
    path: '/frameworks/:framework/edit',
    name: 'app_framework_edit',
    meta: { title: 'Edit a Framework' },
    component: FrameworkEditView,
  },
];
